// extracted by mini-css-extract-plugin
export default {"sticky-container":"styles_sticky-container__TVXf2","hidden":"styles_hidden__N6FhS"};